var exports = {
  "kL": "xdbfd91f1--519d0f--container",
  "VN": "xdbfd91f1--519d0f--close",
  "ld": "xdbfd91f1--519d0f--items",
  "AS": "xdbfd91f1--519d0f--item",
  "Kk": "xdbfd91f1--519d0f--icon",
  "wx": "xdbfd91f1--519d0f--header",
  "GJ": "xdbfd91f1--519d0f--header--link",
  "NW": "xdbfd91f1--519d0f--type",
  "M3": "xdbfd91f1--519d0f--contacts",
  "QZ": "xdbfd91f1--519d0f--phones",
  "OZ": "xdbfd91f1--519d0f--url",
};

module.exports = exports;
